// Thin fetch wrapper. Always sends the session cookie. On 401 the page-level
// calls redirect to the OIDC login; the outbox passes noRedirect so queued
// uploads pause instead of being thrown away.
function toError(status, data, fallback) {
  const err = new Error((data && data.error) || fallback || `http_${status}`);
  err.status = status;
  err.data = data;
  return err;
}

async function request(method, url, body, { noRedirect = false } = {}) {
  let res;
  try {
    res = await fetch(url, {
      method,
      credentials: 'include',
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch (_) {
    throw toError(0, null, 'network');
  }
  if (res.status === 401) {
    if (!noRedirect) {
      const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/auth/login?returnTo=${returnTo}`;
    }
    throw toError(401, null, 'auth_required');
  }
  const data = res.headers.get('content-type')?.includes('application/json') ? await res.json() : null;
  if (!res.ok) throw toError(res.status, data);
  return data;
}

// XHR (not fetch) so we get upload progress.
function putFile(url, blob, mime, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Content-Type', mime);
    xhr.upload.onprogress = (e) => e.lengthComputable && onProgress?.(e.loaded / e.total);
    xhr.onerror = () => reject(toError(0, null, 'network'));
    xhr.ontimeout = () => reject(toError(0, null, 'network'));
    xhr.onload = () => {
      let data = null;
      try { data = JSON.parse(xhr.responseText); } catch (_) { /* not JSON */ }
      if (xhr.status >= 200 && xhr.status < 300) resolve(data);
      else reject(toError(xhr.status, data));
    };
    xhr.send(blob);
  });
}

export const api = {
  get: (url) => request('GET', url),
  post: (url, body) => request('POST', url, body),
  postQuiet: (url, body) => request('POST', url, body, { noRedirect: true }),
  putFile,
};

export const newId = () => crypto.randomUUID();
